"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var lib_1 = require("../../../../lib");
var index_1 = require("../../index");
var cronEnums_1 = require("../cronEnums");
var Days = Array.from(Array(31).keys()).map(function (num) { return ((num + 1).toString()); });
var WeekDays = [
    {
        value: "SUN",
        label: "Sunday"
    },
    {
        value: "MON",
        label: "Monday"
    },
    {
        value: "TUE",
        label: "Tuesday"
    },
    {
        value: "WED",
        label: "Wednesday"
    },
    {
        value: "THU",
        label: "Thursday"
    },
    {
        value: "FRI",
        label: "Friday"
    },
    {
        value: "SAT",
        label: "Saturday"
    }
];
var DaysGenerator = /** @class */ (function (_super) {
    tslib_1.__extends(DaysGenerator, _super);
    function DaysGenerator(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onChangeDaysOption = function (option) {
            _this.setState({ activeDayButton: option });
            _this.generateCronDays();
        };
        _this.onSelectSpecificDaysOfWeek = function (days) {
            _this.setState({ specificDaysOfWeek: (days.length > 0) ? days : ["SUN"] });
            _this.generateCronDays();
        };
        _this.onSelectSpecificDaysOfMonth = function (days) {
            _this.setState({ specificDaysOfMonth: (days.length > 0) ? days : ["0"] });
            _this.generateCronDays();
        };
        _this.onSelectBetweenDaysOfMonthFrom = function (e) {
            var betweenDayOfMonthTo = _this.state.betweenDayOfMonthTo;
            _this.setState({ betweenDayOfMonthFrom: e.target.value });
            if (Number(betweenDayOfMonthTo) < Number(e.target.value)) {
                _this.setState({ betweenDayOfMonthTo: (Number(e.target.value) + 1).toString() });
            }
            _this.generateCronDays();
        };
        _this.onSelectBetweenDaysOfMonthTo = function (e) {
            _this.setState({ betweenDayOfMonthTo: e.target.value });
            _this.generateCronDays();
        };
        _this.onSelectBetweenDaysOfWeekFrom = function (e) {
            _this.setState({ betweenDayOfWeekFrom: e.target.value });
            _this.generateCronDays();
        };
        _this.onSelectBetweenDaysOfWeekTo = function (e) {
            _this.setState({ betweenDayOfWeekTo: e.target.value });
            _this.generateCronDays();
        };
        _this.state = {
            activeDayButton: cronEnums_1.DaysOptions.EveryDay,
            specificDaysOfWeek: ["SUN"],
            specificDaysOfMonth: ["1"],
            betweenDayOfMonthFrom: "1",
            betweenDayOfMonthTo: "31",
            betweenDayOfWeekFrom: "Sun",
            betweenDayOfWeekTo: "SAT",
            cronDays: "*",
        };
        return _this;
    }
    DaysGenerator.prototype.generateCronDays = function () {
        var _this = this;
        setTimeout(function () {
            switch (_this.state.activeDayButton) {
                case cronEnums_1.DaysOptions.EveryDay:
                    _this.setState({ cronDays: "*" });
                    break;
                case cronEnums_1.DaysOptions.EveryDayOfWeekBetween:
                    _this.setState({ cronDays: _this.state.betweenDayOfWeekFrom + "-" + _this.state.betweenDayOfWeekTo });
                    break;
                case cronEnums_1.DaysOptions.EveryDayOfMonthBetween:
                    _this.setState({ cronDays: _this.state.betweenDayOfMonthFrom + "-" + _this.state.betweenDayOfMonthTo });
                    break;
                case cronEnums_1.DaysOptions.SpecificDayOfMonth:
                    _this.setState({ cronDays: _this.state.specificDaysOfMonth.join(",") });
                    break;
                case cronEnums_1.DaysOptions.SpecificDayOfWeek:
                    _this.setState({ cronDays: _this.state.specificDaysOfWeek.join(",") });
                    break;
            }
            _this.props.onGenerate(_this.state.cronDays);
        }, 10);
    };
    DaysGenerator.prototype.render = function () {
        var theme = this.props.theme;
        var _a = this.state, activeDayButton = _a.activeDayButton, specificDaysOfMonth = _a.specificDaysOfMonth, specificDaysOfWeek = _a.specificDaysOfWeek, betweenDayOfMonthFrom = _a.betweenDayOfMonthFrom, betweenDayOfMonthTo = _a.betweenDayOfMonthTo, betweenDayOfWeekFrom = _a.betweenDayOfWeekFrom, betweenDayOfWeekTo = _a.betweenDayOfWeekTo;
        return (React.createElement("div", null,
            React.createElement(lib_1.ButtonsGroup, { active: activeDayButton, onChange: this.onChangeDaysOption, borders: true },
                React.createElement(lib_1.GroupButton, { name: cronEnums_1.DaysOptions.EveryDay }, "Every Day"),
                React.createElement(lib_1.GroupButton, { name: cronEnums_1.DaysOptions.SpecificDayOfWeek }, "Specific Days Of Week"),
                React.createElement(lib_1.GroupButton, { name: cronEnums_1.DaysOptions.SpecificDayOfMonth }, "Specific Days Of Month"),
                React.createElement(lib_1.GroupButton, { name: cronEnums_1.DaysOptions.EveryDayOfWeekBetween }, "Every Day Of Week Between"),
                React.createElement(lib_1.GroupButton, { name: cronEnums_1.DaysOptions.EveryDayOfMonthBetween }, "Every Day Of Month Between")),
            activeDayButton === cronEnums_1.DaysOptions.EveryDay && (React.createElement("div", null,
                React.createElement(index_1.Label, { className: theme.label }, "Run Every Day"))),
            activeDayButton === cronEnums_1.DaysOptions.SpecificDayOfMonth && (React.createElement("div", null,
                React.createElement(index_1.Label, { className: theme.label }, "Run On Specific Days Of Month"),
                React.createElement(index_1.MultiSelect, { surfaceLevel: 0, maxItems: 3, onSelectionChange: this.onSelectSpecificDaysOfMonth, searchable: true, value: specificDaysOfMonth, multiple: true, allowOnlySameGroupSelection: true },
                    React.createElement(index_1.MultiSelectGroup, { value: "selectAllDays", label: "Select All Days" }, Days.map(function (day) { return (React.createElement(index_1.MultiSelectOption, { key: day, value: day, label: day })); }))))),
            activeDayButton === cronEnums_1.DaysOptions.SpecificDayOfWeek && (React.createElement("div", null,
                React.createElement(index_1.Label, { className: theme.label }, "Run On Specific Days Of Week"),
                React.createElement(index_1.MultiSelect, { surfaceLevel: 0, maxItems: 3, onSelectionChange: this.onSelectSpecificDaysOfWeek, searchable: true, value: specificDaysOfWeek, multiple: true, allowOnlySameGroupSelection: true },
                    React.createElement(index_1.MultiSelectGroup, { value: "selectAllDays", label: "Select All Days" }, WeekDays.map(function (day) { return (React.createElement(index_1.MultiSelectOption, { key: day.value, value: day.value, label: day.label })); }))))),
            activeDayButton === cronEnums_1.DaysOptions.EveryDayOfMonthBetween && (React.createElement("div", null,
                React.createElement(index_1.Label, { className: theme.label }, "Run Every Day Of Month Between"),
                React.createElement("div", { className: theme.between },
                    React.createElement(lib_1.FormSelect, { className: theme.select, searchable: true, items: Days.slice(0, 30), maxItems: 5, value: betweenDayOfMonthFrom, onChange: this.onSelectBetweenDaysOfMonthFrom, label: "From Day" }),
                    React.createElement(lib_1.FormSelect, { className: theme.select, searchable: true, items: Days.filter(function (num) { return Number(num) > Number(betweenDayOfMonthFrom); }), maxItems: 5, value: betweenDayOfMonthTo, onChange: this.onSelectBetweenDaysOfMonthTo, label: "To Day" })))),
            activeDayButton === cronEnums_1.DaysOptions.EveryDayOfWeekBetween && (React.createElement("div", null,
                React.createElement(index_1.Label, { className: theme.label }, "Run Every Day Of Week Between"),
                React.createElement("div", { className: theme.between },
                    React.createElement(lib_1.FormSelect, { className: theme.select, searchable: true, items: WeekDays, maxItems: 5, value: betweenDayOfWeekFrom, onChange: this.onSelectBetweenDaysOfWeekFrom, label: "From Day" }),
                    React.createElement(lib_1.FormSelect, { className: theme.select, searchable: true, items: WeekDays, maxItems: 5, value: betweenDayOfWeekTo, onChange: this.onSelectBetweenDaysOfWeekTo, label: "To Day" }))))));
    };
    DaysGenerator.defaultProps = {};
    return DaysGenerator;
}(React.Component));
exports.default = DaysGenerator;
